module.exports = __webpack_public_path__ + "static/media/customPreAssessment2.a86dc523.png";